import React from 'react';
import { useAppStore } from '../../store';
import { Check } from 'lucide-react';

const StatusBar: React.FC = () => {
  const skuCount = useAppStore((s) => s.skus.length);
  const locationCount = useAppStore((s) => s.locations.length);
  const sessionName = useAppStore((s) => s.currentSessionName);
  const hasResults = useAppStore((s) => s.abcResults.length > 0);

  return (
    <footer role="status" style={{
      height: 'var(--status-bar-height)',
      display: 'flex',
      alignItems: 'center',
      padding: '0 var(--space-lg)',
      borderTop: '1px solid var(--border-color)',
      background: 'var(--bg-secondary)',
      fontSize: 'var(--font-size-sm)',
      color: 'var(--text-secondary)',
      gap: 'var(--space-lg)',
      flexShrink: 0,
    }}>
      <span>SKUs: {skuCount.toLocaleString()}</span>
      <span>Locations: {locationCount.toLocaleString()}</span>
      <span>Session: {sessionName}</span>
      {hasResults && <span style={{ color: 'var(--color-success)', display: 'inline-flex', alignItems: 'center', gap: 'var(--space-xs)' }}><Check size={12} /> Classified</span>}
    </footer>
  );
};

export default StatusBar;
